import { createContext, useCallback, useState } from "react";
import API from "services/api";

export const PartnerContext = createContext({});

const PartnerProvider = (props) => {
  const [totalCount, setTotalCount] = useState(0);
  const [dataPartner, setDataPartner] = useState({});
  const [detailPartner, setDetailPartner] = useState({});
  const [partnerCategories, setPartnerCategories] = useState([]);
  const getPartnerCategories = useCallback(async (params) => {
    try {
      const res = await API.getPartnerCategories(params);
      const { data } = res.data;
      setPartnerCategories(data);
    } catch (err) {
      console.log("err", err);
    }
  }, []);
  const getPartnerContent = useCallback(async (params) => {
    try {
      const res = await API.getAllPartner(params);
      const { data, totalCount } = res.data;
  
      setDataPartner(data);
      setTotalCount(totalCount);
    } catch (err) {
      console.log("err", err);
    }
  }, []);
  const getDetailPartner = useCallback(async (id, params) => {
    await API.getPartnerById(id, params)
      .then((res) => {
        const data = res.data;
        // console.log("data", data);
        const category = data[0].category?._id;
        const newData = { ...data[0], category };
        setDetailPartner(newData);
      })
      .catch((err) => console.log("err", err));
  }, []);
return (
    <PartnerContext.Provider
      value={{
        dataPartner,
        detailPartner,
        partnerCategories,
        getPartnerContent,
        getDetailPartner,
        getPartnerCategories,
      }}
      {...props}
    />
  );
};
export default PartnerProvider;